import { z } from "zod"

const mainRunCarrierSelfSchema = z.object({
    type: z.literal("SELF"),
    load_id: z.string(),
    asset_id: z.string(),
    access_code: z.optional(z.string()),
})

const mainRunCarrierThirdPartySchema = z.object({
    type: z.literal("THIRD_PARTY"),
    bundle_id: z.string(),
})

const mainRunCarrierSchema = z.discriminatedUnion("type", [mainRunCarrierSelfSchema, mainRunCarrierThirdPartySchema])

export type MainRunCarrierRest = z.infer<typeof mainRunCarrierSchema>

const timeWindowSchema = z.object({
    time_from: z.string(),
    time_to: z.string(),
})

export type TimeWindowRest = z.infer<typeof timeWindowSchema>

const mainRunSchema = z.object({
    asn_tracking_number: z.string(),
    supplier_duns: z.string(),
    loading_time_window: timeWindowSchema,
    main_run_carrier: mainRunCarrierSchema,
    cross_dock_id: z.string(),
})

export type MainRunDataRest = z.infer<typeof mainRunSchema>

export const mainRunListSchema = z.object({
    items: z.array(mainRunSchema)
})

const crossDockSchema = z.object({
    id: z.string(),
    name: z.string(),
})

export type CrossDockRest = z.infer<typeof crossDockSchema>

export const crossDockListSchema = z.array(crossDockSchema)

const mainRunViolationErrorSchema = z.enum([
    "ACCESS_CODE_INVALID",
    "ASN_NOT_FOUND",
    "ASN_TRACKING_NUMBER_MISSING",
    "ASN_TRACKING_NUMBER_INVALID",
    "ASSET_ID_MISSING",
    "ASSET_ID_INVALID",
    "ASSET_ID_NOT_FOUND",
    "BUNDLE_ID_MISSING",
    "BUNDLE_ID_INVALID",
    "CROSS_DOCK_ID_MISSING",
    "CROSS_DOCK_ID_INVALID",
    "CROSS_DOCK_ID_NOT_FOUND",
    "LOAD_ID_MISSING",
    "LOAD_ID_INVALID",
    "LOADING_TIME_WINDOW_INVALID",
    "LOADING_TIME_WINDOW_FROM_MISSING",
    "LOADING_TIME_WINDOW_FROM_INVALID",
    "LOADING_TIME_WINDOW_TO_MISSING",
    "LOADING_TIME_WINDOW_TO_INVALID",
    "LOADING_TIME_WINDOW_IN_PAST",
    "MATCHING_CONTEXT_NOT_FOUND",
    "MATCHING_CONTEXT_CANCELLED",
    "SUPPLIER_DUNS_MISSING",
    "SUPPLIER_DUNS_INVALID",
])

const mainRunViolationSchema = z.object({
    index: z.number(),
    errors: z.array(mainRunViolationErrorSchema),
})

export type ExternalMainRunViolation = z.infer<typeof mainRunViolationSchema>

export const mainRunProblemsSchema = z.object({
    main_run_violations: z.array(mainRunViolationSchema),
})

export type ExternalMainRunProblems = z.infer<typeof mainRunProblemsSchema>
